// extracted by mini-css-extract-plugin
export default {"snetLogo":"SnetLogo_snetLogo__DGaa6"};